import React from 'react';
import dateformat from 'dateformat';

import * as S from './TripRefundDetails.styles';

import IconSelector from '@ibibo/icon-selector';

const TripRefundDetails = ({data}) => {
  const {refund_status = [], status_message} = data;
  const widthStep = 100 / (refund_status.length || 1);
  return(
    <S.TripInfoDetailsInnerWrap>
      <S.TripDetailOuterWrap>
        {(refund_status.map((status, index) => <S.RefundInfoBlock key={`status${index}`}>
          {status.completed &&
            <S.TripRefundStatus>
              <S.TripRefundStatusFilled width={(widthStep * (index + 1)) + '%'} />
            </S.TripRefundStatus>
          }
          {status.completed ? <S.RefundSatusTickWrap>
            <IconSelector iconKey='whitetick' />
          </S.RefundSatusTickWrap> : <S.RefundSatusCountWrap>
            <S.RefundStatusCountText>{index + 1}</S.RefundStatusCountText>
          </S.RefundSatusCountWrap>}
          <S.RefundStatusTextWrap>
            <S.BkngStatus>{status.state}</S.BkngStatus>
            <S.RefundStatTime>{status.date}</S.RefundStatTime>
          </S.RefundStatusTextWrap>
        </S.RefundInfoBlock>))}
      </S.TripDetailOuterWrap>
      {(status_message && <S.TripAdditionInfoWrap>
        <S.RefundStatus>{status_message}</S.RefundStatus>
      </S.TripAdditionInfoWrap>) || null}
    </S.TripInfoDetailsInnerWrap>
  );
}

export default TripRefundDetails;